import { ColorScheme } from "~/enums/colorScheme";
import DashboardElement from "~/models/dashboards/dashboardElement";
import DashboardElementAnalyticValidation from "~/models/navigableValidations/dashboardElementAnalyticValidation";
import Visualization from "~/models/visualizations/visualization";
import { GlobalColors } from "~/modules/gColors/colorsEnum";
import ListView from "~/models/listViews/listView";

export default class Analytic extends DashboardElement {
  visualization_id: string;
  visualization: Visualization;
  list_view: ListView;
  theme_color: number;
  drill_down: boolean;
  enable_reporting_and_submissions_link: boolean
  form_id: string;
  list_view_id: string;
  object_model_id: string;


  constructor() {
    super();
    this.defineProperty("visualization_id", '');
    this.defineProperty("theme_color", ColorScheme.BlueGreen);
    this.defineProperty("drill_down", false);
    this.defineProperty("enable_reporting_and_submissions_link", false);
    this.defineProperty("form_id", '');
    this.defineProperty("list_view_id", '');
    this.defineProperty("object_model_id", '');
  }

  except: ["visualization", "dashboard_elements"]

  _validation: DashboardElementAnalyticValidation = new DashboardElementAnalyticValidation(this)

  get colorSchemes() {
    switch (this.theme_color) {
      case ColorScheme.BlueGreen:
        return [GlobalColors.Mariner, GlobalColors.Denim, GlobalColors.Lake, GlobalColors.Laurel, GlobalColors.Boulder];
      case ColorScheme.RedPurple:
        return [GlobalColors.Cinnabar, GlobalColors.Rust, GlobalColors.Fuchsia, GlobalColors.BlueViolet, GlobalColors.Boulder];
      case ColorScheme.PurpleBlue:
        return [GlobalColors.Fuchsia, GlobalColors.BlueViolet, GlobalColors.Mariner, GlobalColors.Lake, GlobalColors.Boulder];
      case ColorScheme.WarnNeutral:
        return [GlobalColors.Rust, GlobalColors.Brown, GlobalColors.Tan, GlobalColors.Charcoal, GlobalColors.Boulder];
      case ColorScheme.Executive:
        return [GlobalColors.Charcoal, GlobalColors.Boulder, GlobalColors.Cinnabar, GlobalColors.Mariner, GlobalColors.Boulder];
      case ColorScheme.Greyscale:
        return [GlobalColors.Charcoal, GlobalColors.Boulder, GlobalColors.SilverChalice, GlobalColors.Antimony, GlobalColors.Moon];
      case ColorScheme.ColorBlind:
        return [GlobalColors.Mariner, GlobalColors.Rust, GlobalColors.Charcoal, GlobalColors.Denim, GlobalColors.Moon];
      default:
        return []
    }
  }

}
